import { LinkData, NavigationLinks, SubMenu } from '@mewa/types';

import t from '../../../libs/translate';
import { trackCustomEvent } from '../../helpers/tracking-helper';
import { getServiceSegmentSlugForIndustry } from '../../templates/industry-page-helper';
import { NavigationData } from './types';

export const getProductMenuWithOverviewPages = (
  navigationData: NavigationData,
  locale: string,
  marketHasClothingSegments: boolean,
  featureDev?: boolean,
): SubMenu[] => {
  const {
    navigationLinks: { navigation },
    navigationClothing: { nodes: clothingLinks },
    navigationNonClothing: { nodes: nonClothingLinks },
    navigationCleanRoom: { nodes: cleanRoomLinks },
    navigationIndustries: { nodes: industrieLinks },
  } = navigationData;

  const industryMenu = getIndustryLinks(
    industrieLinks,
    navigation,
    marketHasClothingSegments,
    featureDev,
  );

  return [
    {
      title: navigation.clothing.name,
      slug: navigation.clothing.slug,
      links: clothingLinks,
    },
    {
      title: navigation.nonClothing.name,
      slug: navigation.nonClothing.slug,
      links: nonClothingLinks,
    },
    ...(['de-DE', 'de-AT', 'de-CH'].includes(locale)
      ? [
          {
            title: navigation.cleanroom.name,
            slug: navigation.cleanroom.slug,
            links: cleanRoomLinks,
          },
        ]
      : []),
    {
      title: navigation.industries.name,
      slug: navigation.industries.slug,
      links: industryMenu,
    },
  ];
};

const getIndustryLinks = (
  industries: NavigationData['navigationIndustries']['nodes'],
  navigation: NavigationLinks['navigation'],
  marketHasClothingSegments: boolean,
  featureDev?: boolean,
) =>
  industries.map((industry) => {
    const ServiceSegmentSlug = getServiceSegmentSlugForIndustry(
      industry,
      navigation,
      marketHasClothingSegments,
      featureDev,
    );

    return {
      name: industry.name,
      slug: `${industry.slug}-${ServiceSegmentSlug}`,
    };
  });

export const getCompanyMenu = (
  {
    headerAndFooterTranslations: translations,
    navigationLinks,
    marketLanguageConfig,
  }: NavigationData,
  featureDev?: boolean,
): SubMenu => {
  const companyLinks: LinkData[] = [
    // TODO: Add new company subpages here  with featureDev check(navigationLinks.companyNachhaltigkeit ...)
    ...(featureDev ? [navigationLinks.companyHistory] : []),
    ...(featureDev ? [navigationLinks.companySustainability] : []),
    ...(featureDev ? [navigationLinks.companySponsoring] : []),
    ...(featureDev ? [navigationLinks.companyLocation] : []),
    // blog is included in this market
    ...(marketLanguageConfig.blog === 'true'
      ? [navigationLinks.blog.generalSlug]
      : []),
    navigationLinks.pressOverview,
    {
      name: t(translations, 'footer_career'),
      slug: marketLanguageConfig.careerPortal,
      isExternal: true,
      handleClick: () => {
        trackCustomEvent('external_career_header');
      },
    },
    // add an external link to the blog
    ...(marketLanguageConfig.blog &&
    marketLanguageConfig.blog !== '' &&
    marketLanguageConfig.blog !== 'true'
      ? [
          {
            name: t(translations, 'footer_mewa_blog'),
            slug: marketLanguageConfig.blog,
            isExternal: true,
          },
        ]
      : []),
  ];

  return {
    slug: featureDev
      ? navigationLinks.companyHomepage.slug
      : navigationLinks.navigation.company.slug,
    title: featureDev
      ? navigationLinks.companyHomepage.name
      : navigationLinks.navigation.company.name,
    links: companyLinks,
  };
};
